/**
 * Блок «Мы на связи» перед футером: карточки Discord, ВКонтакте и форума.
 * Ссылки — из настроек сайта (те же, что в футере).
 */
import React from 'react';
import { useSiteConfig } from '../../contexts/SiteConfigContext';
import discordLogo from '../../images/social/discord_brand.svg';
import vkLogo from '../../images/social/vk_brand.svg';
import forumIcon from '../../images/forum.svg';
import { rvDelay } from '../../utils/sectionReveal';
import styles from './community.module.css';

const Arrow = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M7 17L17 7M9 7h8v8" />
  </svg>
);

const Community: React.FC = () => {
  const { links } = useSiteConfig();
  const cards = [
    { key: 'ds', cls: styles.ds, img: discordLogo, name: 'Discord', text: 'Общение с игроками, анонсы ивентов и поддержка администрации', btn: 'Вступить', href: links.discord },
    { key: 'vk', cls: styles.vk, img: vkLogo, name: 'ВКонтакте', text: 'Новости проекта, обновления и анонсы', btn: 'Подписаться', href: links.vk },
    { key: 'fr', cls: styles.fr, img: forumIcon, name: 'Форум', text: 'Обсуждения, заявки и гайды от игроков', btn: 'Открыть форум', href: links.forum },
  ].filter(c => !!c.href);

  return (
    <section className={styles.section} id="community">
      <div className={styles.bg} aria-hidden="true" />
      <h2 className={`${styles.title} rv`} style={rvDelay(0.05)}>Мы на связи</h2>
      <div className={`${styles.line} rv rv-line`} style={rvDelay(0.2)} />
      <p className={`${styles.lead} rv`} style={rvDelay(0.28)}>Новости сервера, анонсы ивентов и живое общение с игроками</p>
      <div className={styles.grid}>
        {cards.map(c => (
          <a key={c.key} className={`${styles.card} ${c.cls}`} href={c.href} target="_blank" rel="noopener noreferrer">
            <span className={styles.icon}><img src={c.img} alt="" /></span>
            <span className={styles.name}>{c.name}</span>
            <span className={styles.text}>{c.text}</span>
            <span className={styles.btn}>{c.btn}<Arrow /></span>
          </a>
        ))}
      </div>
    </section>
  );
};

export default Community;
